import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

import { AppComfirmComponent } from './app-confirm.component';
import { ConfirmData } from './confirm-data';
import { LayoutService } from '../layout.service';

@Injectable({
  providedIn: 'root'
})

export class AppConfirmService {

  public layoutConf: any;

  constructor(
    private dialog: MatDialog,
    private layout: LayoutService,
  ) { }

  public confirm(data: ConfirmData = {}): Observable<any> {
    this.layoutConf = this.layout.layoutConf;
    data.title = data.title || '';
    data.message = data.message || '';

    // Quem informa `error` (true OU false) está relatando o RESULTADO de uma operação, não fazendo
    // uma pergunta — e aviso com "Sim/Não" é sem sentido: não há o que recusar em "salvo com
    // sucesso". Pergunta simplesmente não passa `error`; a que precisar passar pede os dois botões
    // explicitamente com `disableCancel: false`, que tem precedência.
    const ehAviso = data.alert ?? (data.error !== undefined);

    data.error = data.error || false;
    data.defaultOption = data.defaultOption || true;
    if (data.error) {
      try { this.playAudioError(); }
      catch (e: unknown) { 
      }
    }
    // console.log('OPENING DIALOG')
    
    let dialogRef: MatDialogRef<AppComfirmComponent>;
    
    dialogRef = this.dialog.open(AppComfirmComponent, {
      width: this.layout.isMobile ? '70%' : '40%',
      disableClose: true,
      data: {
        title: data.title,
        message: data.message,
        error: data.error,
        options: data.options,
        defaultOption: data.defaultOption,
        containsText: data.containsText,
        messageOptions: data.messageOptions,
        disableCancel: data.disableCancel ?? ehAviso,
        selectedText: data.selectedText,
        icon: data.icon,
        okText: data.okText,
        cancelText: data.cancelText 
      }
    });
    return dialogRef.afterClosed();
  }

  playAudioError() {
    const audio = new Audio();
    audio.src = 'assets/sounds/error.mp3';
    audio.load();
    audio.play();
  }

}